module.exports = __webpack_public_path__ + "static/media/garment.9b7965bc.png";